<template>
  <div class="h5-tabbar">
    <div class="h5-tabbar-item" :class="{ active: active === 'orders' }" @click="go('/h5/orders')">
      <a-icon type="profile" />
      <span>订单</span>
    </div>
    <div class="h5-tabbar-item" :class="{ active: active === 'partners' }" @click="go('/h5/partners')">
      <a-icon type="team" />
      <span>伙伴</span>
    </div>
    <div class="h5-tabbar-item" :class="{ active: active === 'scan' }" @click="go('/h5/scan')">
      <a-icon type="scan" />
      <span>扫码入库</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'H5TabBar',
  props: {
    active: { type: String, default: 'orders' }
  },
  methods: {
    go(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>
<style scoped>
.h5-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  padding: 6px 0 calc(6px + env(safe-area-inset-bottom));
  z-index: 100;
}
.h5-tabbar-item {
  flex: 1;
  text-align: center;
  color: #666;
  font-size: 12px;
  line-height: 1.4;
}
.h5-tabbar-item i {
  font-size: 20px;
  display: block;
}
.h5-tabbar-item.active {
  color: #1890ff;
}
</style>
